import {fetchWithState, getFetchedJSON} from '~/misc/fetch';

export const companyBroker = (getState, data) => fetchWithState(getState, {
  url: '/tl/broker',
  method: 'POST',
  body: {
    broker_id: data.id,
    company: data.company,
    operate: data.operate,
  },
  header: {
    'Cache-control': 'no-cache',
    'Pragma': 'no-cache',
  },
}, false).then(getFetchedJSON);
export const addMyCompanies = (getState, data) => fetchWithState(getState, {
  url: `/tl/myBroker?status=${ data}`,
  header: {
    'Cache-control': 'no-cache',
    'Pragma': 'no-cache',
  },
}, false).then(getFetchedJSON);



// WEBPACK FOOTER //
// ./src/api/company.js